import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchTagService } from '../../service/search-tag.service';
import { ToastrService } from 'ngx-toastr';
import { SearchConditionService } from '../../service/search-condition.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search-tag-register',
  templateUrl: './search-tag-register.component.html',
  styleUrls: ['./search-tag-register.component.scss']
})
export class SearchTagRegisterComponent implements OnInit, OnDestroy {
  @Input() searchParams: SearchCondition;
  name: string;
  modalRef: NgbActiveModal;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private modalService: NgbModal,
    private searchTagService: SearchTagService,
    private toastrService: ToastrService,
    private searchConditionService: SearchConditionService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  open(content): void {
    this.modalRef = this.modalService.open(content, {
      windowClass: 'search-tag-register-modal'
    });
  }

  registerTag(): void {
    const createParams = this.createParams();
    if (createParams) {
      const registerSub = this.searchTagService.createSearchTag(createParams).subscribe(res => {
        this.toastrService.success('ボタン登録に成功しました。');
        this.searchTagService.searchTagListSubject.next();
        this.name = '';
        this.modalRef.close();
      });
      this.subscriptions.add(registerSub);
    }
  }

  EnterOnRegister(event): void {
    if (event.key === 'Enter' && !event.isComposing) {
      event.preventDefault();
      this.registerTag();
    }
  }

  // タグ作成リクエストで必要なパラムの作成
  // 作成時にパラムの検証を行う
  private createParams(): object {
    // 検索条件の検証
    if (this.searchConditionService.areAttributesValidated(this.searchParams)) {
      const tagParams = this.searchConditionService.tagParams(
        this.searchParams
      );
      // 検索条件の入力チェック
      if (Object.keys(tagParams).length !== 1) {
        return {
          name: this.name,
          search_params: tagParams
        };
      } else {
        this.toastrService.info('登録する検索条件の入力をお願いします。');
        return;
      }
    }
  }
}
